var PhoneNumberPattern = {
  MOBILE: new RegExp('^04\\d{8}$'),
  LANDLINE_WITH_AREA: new RegExp('^\\d{10}$'),
  LANDLINE_NO_AREA: new RegExp('^\\d{8}$'),
  SMART_NUMBER_A: new RegExp('^13\\d{4}$'),
  SMART_NUMBER_B: new RegExp('^1300\\d{6}$'),
  SMART_NUMBER_C: new RegExp('^1800\\d{6}$')
};
export default PhoneNumberPattern;